module.exports = __webpack_public_path__ + "img/avataaars (3).5939409d.svg";